import React from 'react';
import {PortableText} from '@portabletext/react';

export default function BlockText({body}) {
  return (
    <>
      {body
        ? body.map((block) => {
            return (
              <div key={block._key}>
                {block._type !== 'block' || !block.children ? (
                  ''
                ) : (
                  <PortableText value={block} />
                )}
              </div>
            );
          })
        : ''}
    </>
  );
}
